import React  from "react";

import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import CodeExample from "../../partials/content/CodeExample";
import { updateMaster } from "../../crud/auth.crud";

import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,

  KeyboardDatePicker,
} from '@material-ui/pickers';



const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class EditPatient extends React.Component {
  state = {
    fields:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
  }



  handleDateChange = (date: Date | null) => {
    this.setState({selDate:date});
  };

  handleZipChange = (e) => {

    const {setFieldValue} = this.props;
    console.log(e.target.name);
    console.log(e.target.value);

    setFieldValue("country", "USA");
    setFieldValue("state", "MA");
    setFieldValue("city", "Boston");
  };



constructor(props)
{
  super(props);
    this.state = {
      menu: false,
      fields:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
      accounts:[],
      postObj:{},
      fromPath:'',
      page:1
    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}
  
  
  toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }

  componentDidMount()
  {
    
    if(this.props.location!==null && this.props.location.data.pEntity!==null)
    {
        this.setState({pEntity:this.props.location.data.pEntity});
        //console.log("first",this.props.location.data.pEntity.dateOfBirth);
        this.setState({dob:this.props.location.data.pEntity.dateOfBirth});
        //console.log("last",this.state.dob);
     
    }
      if(this.props.location.fromPath!==null) this.setState({fromPath: this.props.location.fromPath});
      if(this.props.location.postObj!==null) this.setState({postObj: this.props.location.postObj});
      if(this.props.location.page!==null) this.setState({page: this.props.location.page});
      console.log("props::::",this.props.location);
      console.log("dob:::",this.state.dob);

  }

  async componentWillReceiveProps(nextProps)
{
  if(this.props.location!==null && this.props.location.data.pEntity!==null)
    {
        this.setState({pEntity:this.props.location.data.pEntity});
        console.log("first",this.props.location.data.pEntity);
        this.setState({dob:this.props.location.data.pEntity.dataOfBirth});
        console.log("last",this.state.dob);
     
    }
      if(this.props.location.fromPath!==null) this.setState({fromPath: this.props.location.fromPath});
      if(this.props.location.postObj!==null) this.setState({postObj: this.props.location.postObj});
      if(this.props.location.page!==null) this.setState({page: this.props.location.page});
      console.log("props::::",this.props.location);
      console.log("dob:::",this.state.dob);
}



  
handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
           
    }

    
  
} 



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;

    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

          { this.state.pEntity!=null &&

           <Formik
                  initialValues={{
                    firstName:this.state.pEntity.firstName,
                    lastName:this.state.pEntity.lastName,
                    middleName:this.state.pEntity.middleName,
                    dateOfBirth:this.state.pEntity.dateOfBirth,
                    email:this.state.pEntity.email,
                    mobile:this.state.pEntity.mobile,
                    secondaryMobile:this.state.pEntity.secondaryMobile,
                    address:this.state.pEntity.address,
                    pinCode:this.state.pEntity.pinCode,
                    city:this.state.pEntity.city,
                    state:this.state.pEntity.state,
                    country:this.state.pEntity.country,
                    gender:this.state.pEntity.gender,
                    patientId:this.state.pEntity.patientId
                    
                  }}
                  validate={values => {
                    const errors = {};

                    if (values.email) {
                      if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    ) {
                      errors.email = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.INVALID_FIELD"
                      });
                    }
                    }

                    if (!values.firstName) {
                      errors.firstName = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.lastName) {
                      errors.lastName = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.mobile) {
                      errors.mobile = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                    
                    if (!values.patientId) {
                      errors.patientId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                    

                  {/*  if (!values.dateOfBirth) {
                      errors.dateOfBirth = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }*/}


                    /*
                    if (!values.city) {
                      errors.city = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                    if (!values.pinCode) {
                      errors.pinCode = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.state) {
                      errors.state = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.country) {
                      errors.country = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                    */
                   if (!values.gender) {
                      errors.gender = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                  

                   

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({loading:true});
                   let data ={
                      'firstName': values.firstName,
                      'lastName': values.lastName,
                      'middleName': values.middleName,
                      'dateOfBirth':this.state.dob,
                      'email':values.email,
                      'mobile':values.mobile,
                      'secondaryMobile':values.secondaryMobile,
                      'address':values.address,
                      'address':values.address,
                      'city':values.city,
                      'state':values.state,
                      'country':values.country,
                      'gender':values.gender,
                      'patientId':values.patientId
                    };

                   updateMaster('pentityupdate',this.state.pEntity.pEntityId,data)
                      .then(resp => {
                        //props.register(accessToken);
                        this.setState({status:true,
                        statusMessage:'Patient updated successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                        
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
        	
      		<CodeExample beforeCodeTitle="Basic Details">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           

		   			
		   			<div className="row">
		   			          

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="First Name"
                          className="kt-width-full"
                          name="firstName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.firstName}
                          helperText={touched.firstName && errors.firstName}
                          error={Boolean(touched.firstName && errors.firstName)}
                        />
                      </div>        

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Middle Name"
                          className="kt-width-full"
                          name="middleName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.middleName}
                          helperText={touched.middleName && errors.middleName}
                          error={Boolean(touched.middleName && errors.middleName)}
                        />
                      </div>      

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Last Name"
                          className="kt-width-full"
                          name="lastName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.lastName}
                          helperText={touched.lastName && errors.lastName}
                          error={Boolean(touched.lastName && errors.lastName)}
                        />
                      </div>

                      <div className="col-6">
                        {/*<TextField
                          margin="normal"
                          label="DOB"
                          className="kt-width-full"
                          name="dateOfBirth"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.dateOfBirth}
                          helperText={touched.dateOfBirth && errors.dateOfBirth}
                          error={Boolean(touched.dateOfBirth && errors.dateOfBirth)}
                        />*/}
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="dataOfBirth"
                              name="dataOfBirth"
                              label="DOB"
                              value={this.state.dob}
                              maxDate={new Date()}
                              onChange={value => {
                                this.setState({dob:value})
                              }}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />

                        </Grid>
                        </MuiPickersUtilsProvider>
                      </div>

                      <div className="col-6">
                        <TextField
                              labelId="gender-label"
                              id="gender"
                              margin="normal"
                              name="gender"
                              value={values.gender}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className="kt-width-full"
                              label="Select Gender"
                              style={{'width':'100%'}}
                            select>
                             
                              <MenuItem key="male" value="male">Male</MenuItem>
                              <MenuItem key="female" value="female">Female</MenuItem>
                              
                            </TextField>
                      </div>

                      <div className="col-6">
                        <TextField
                          label="Email"
                          margin="normal"
                          className="kt-width-full"
                          name="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.email}
                          helperText={touched.email && errors.email}
                          error={Boolean(touched.email && errors.email)}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Mobile"
                          className="kt-width-full"
                          name="mobile"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.mobile}
                          helperText={touched.mobile && errors.mobile}
                          error={Boolean(
                            touched.mobile && errors.mobile
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Secondary Contact"
                          className="kt-width-full"
                          name="secondaryMobile"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.secondaryMobile}
                          helperText={touched.secondaryMobile && errors.secondaryMobile}
                          error={Boolean(
                            touched.secondaryMobile && errors.secondaryMobile
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Address line 1"
                          className="kt-width-full"
                          name="address"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.address}
                          helperText={touched.address && errors.address}
                          error={Boolean(
                            touched.address && errors.address
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Zipcode"
                          className="kt-width-full"
                          name="pinCode"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.pinCode}
                          helperText={touched.pinCode && errors.pinCode}
                          error={Boolean(
                            touched.pinCode && errors.pinCode
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="City"
                          className="kt-width-full"
                          name="city"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.city}
                          helperText={touched.city && errors.city}
                          error={Boolean(
                            touched.city && errors.city
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="State"
                          className="kt-width-full"
                          name="state"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.state}
                          helperText={touched.state && errors.state}
                          error={Boolean(
                            touched.state && errors.state
                          )}
                        />
                      </div>

                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Country"
                          className="kt-width-full"
                          name="country"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.country}
                          helperText={touched.country && errors.country}
                          error={Boolean(
                            touched.country && errors.country
                          )}
                        />
                      </div>
                      <div className="col-6">
                        <TextField
                          margin="normal"
                          label="Patient ID"
                          className="kt-width-full"
                          name="patientId"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.patientId}
                          helperText={touched.patientId && errors.patientId}
                          error={Boolean(
                            touched.patientId && errors.patientId
                          )}
                        />
                      </div>
                      
		   			  </div>
              <div className="row">
                <div className="col-6">
                </div>
              </div>
              
              <div className="row">
                <div className="col-lg-12">
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                
                
                  </div>  
              </div>
				   
			    </div>
		    </div>
		    </CodeExample>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update
                        </button> &nbsp;
                        <Link to={{pathname:this.state.fromPath,data: this.state.postObj,page:this.state.page}}>Back</Link>
                      </div>
       </form>
            )}
            </Formik>

            }
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditPatient));

